/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { RewardConfigResponse } from './RewardConfigResponse';
import {
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
    RewardConfigResponseToJSONTyped,
} from './RewardConfigResponse';

/**
 * 
 * @export
 * @interface GetRewardConfigsResponse
 */
export interface GetRewardConfigsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetRewardConfigsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<RewardConfigResponse>}
     * @memberof GetRewardConfigsResponse
     */
    rewards: Array<RewardConfigResponse>;
}

/**
 * Check if a given object implements the GetRewardConfigsResponse interface.
 */
export function instanceOfGetRewardConfigsResponse(value: object): value is GetRewardConfigsResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('rewards' in value) || value['rewards'] === undefined) return false;
    return true;
}

export function GetRewardConfigsResponseFromJSON(json: any): GetRewardConfigsResponse {
    return GetRewardConfigsResponseFromJSONTyped(json, false);
}

export function GetRewardConfigsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRewardConfigsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'rewards': ((json['rewards'] as Array<any>).map(RewardConfigResponseFromJSON)),
    };
}

export function GetRewardConfigsResponseToJSON(json: any): GetRewardConfigsResponse {
    return GetRewardConfigsResponseToJSONTyped(json, false);
}

export function GetRewardConfigsResponseToJSONTyped(value?: GetRewardConfigsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'rewards': ((value['rewards'] as Array<any>).map(RewardConfigResponseToJSON)),
    };
}

